

































































import {
  defineComponent,
  ref,
  useRouter,
  useRoute,
  inject,
  Ref
} from '@nuxtjs/composition-api';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { useUser, useCart } from '@wemade-vsf/customer';
import { useWishlist } from '@wemade-vsf/wishlist';

import {
  SfInput,
  SfButton,
  SfLoader,
  SfHeading
} from '@storefront-ui/vue';

extend('email', {
  ...email,
  message: 'Invalid email',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

interface FormFields {
  email: string;
  password: string;
}

export default defineComponent({
  components: {
    SfInput,
    SfButton,
    SfLoader,
    SfHeading,
    ValidationObserver,
    ValidationProvider,
    ForgotPasswordModal: () => import('components/checkout/Account/ForgotPasswordModal.vue')
  },
  setup (props, { emit }) {
    const { login, loading, error: loginError, user } = useUser();
    const { load: loadCart } = useCart();
    const { loadItemsCount } = useWishlist();
    const router = useRouter();
    const route = useRoute();
    const taxOff = inject<Ref<boolean> | undefined>('taxOff');
    const formData = ref<FormFields>({ email: '', password: '' });
    const localLoginError = ref<string | null>(null);

    const onFormSubmit = async () => {
      try {

        localLoginError.value = null;

        await login({ user: formData.value });
        await Promise.all([loadItemsCount(), loadCart()]);

        if (route.value.path === '/checkout/konto') {
          if (user.value?.taxvat) {
            await router.push('/checkout/bestilling');
          } else if (!user.value?.taxvat) {
            await router.push('/sveacheckout');
          }
        }


        emit('user:loggedin');
        localStorage.setItem('taxOff', 'true');
        if (taxOff) taxOff.value = true;
        console.log("User logged in successfully.");
      } catch (error) {
        console.error("Error during login:", error);
        localLoginError.value = error.message || "An unexpected error occurred.";
      }
    };

    const showForgotPasswordModal = ref(false);

    return {
      formData,
      loading,
      localLoginError,
      onFormSubmit,
      showForgotPasswordModal
    };
  }
});
